var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDroplet = function SvgDroplet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "droplet_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.66 8.35 12 2.69 6.35 8.35a8 8 0 1 0 11.31 0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgDroplet as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTcuNjU5OSA4LjM0OTk0TDExLjk5OTkgMi42ODk5NEw2LjM0OTg5IDguMzQ5OTRDNS4yMzA1NCA5LjQ2ODU1IDQuNDY4MDkgMTAuODk0IDQuMTU4OTkgMTIuNDQ2QzMuODQ5ODggMTMuOTk4IDQuMDA4IDE1LjYwNjggNC42MTMzNSAxNy4wNjg5QzUuMjE4NyAxOC41MzEgNi4yNDQwNyAxOS43ODA4IDcuNTU5NzggMjAuNjZDOC44NzU0OSAyMS41MzkzIDEwLjQyMjQgMjIuMDA4NiAxMi4wMDQ5IDIyLjAwODZDMTMuNTg3NCAyMi4wMDg2IDE1LjEzNDMgMjEuNTM5MyAxNi40NSAyMC42NkMxNy43NjU3IDE5Ljc4MDggMTguNzkxMSAxOC41MzEgMTkuMzk2NCAxNy4wNjg5QzIwLjAwMTggMTUuNjA2OCAyMC4xNTk5IDEzLjk5OCAxOS44NTA4IDEyLjQ0NkMxOS41NDE3IDEwLjg5NCAxOC43NzkyIDkuNDY4NTUgMTcuNjU5OSA4LjM0OTk0WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";